import { useStorytellClient } from "../storytellClient";
import { SearchAssetsRequestConfig } from "./assetClient.api";
import type { SearchAssetsParams, SearchAssetsResponse } from "./assetClient.types";

class AssetClient {
  private token: string | undefined;
  private client = useStorytellClient();

  constructor(token?: string) {
    this.token = token;
  }

  /**
   * Metadata search across assets, project-scoped and limited to readable assets. A filter-only
   * query (no `q`) is valid; soft-deleted assets are never returned. Throws on transport/HTTP
   * failure.
   */
  async searchAssets(params: SearchAssetsParams): Promise<SearchAssetsResponse> {
    const config = SearchAssetsRequestConfig.withBearerToken(this.token);
    const result = await this.client.fetch(config, params, undefined);

    if (result.isErr()) {
      throw result.error;
    }

    return result.value;
  }
}

export const createAssetClient = (token?: string): AssetClient => {
  return new AssetClient(token);
};
